import { render, staticRenderFns } from "./Chichi.vue?vue&type=template&id=83f1ea5e&scoped=true"
import script from "./Chichi.vue?vue&type=script&lang=js"
export * from "./Chichi.vue?vue&type=script&lang=js"
import style0 from "./Chichi.vue?vue&type=style&index=0&id=83f1ea5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83f1ea5e",
  null
  
)

export default component.exports